<template>
  <span @click.stop="openWhatsApp" class="pointer">
    <v-hover v-slot="{ hover }">
      <v-icon :color="hover ? 'primary' : 'lightText'">mdi-whatsapp</v-icon>
    </v-hover>
  </span>
</template>

<script>
import Services from '@/services'

export default {
  props: {
    phone: {
      type: String
    },
    subject: {
      type: Object
    },
    clickType: {
      type: Number
    },
    orderId: {
      type: String
    }
  },
  methods: {
    getPlaceLabel (places, anyDestinationKey) {
      if (!places || !places[0]) {
        return this.$t(anyDestinationKey)
      }

      const place = places[0]
      let label = place.country.toUpperCase()
      label += place.place ? place.place.postalCode : place.postalCode
      return label
    },
    getWhatsAppMessage () {
      if (this.$store.getters.userCommonData.whatsAppTeaserActive === false) {
        return ''
      }

      const loading = this.getPlaceLabel(this.subject?.loadingPlaces, 'myVehicle.anyDestination')
      const unloading = this.getPlaceLabel(this.subject?.unloadingPlaces, 'myVehicle.anyDestination')

      return this.$t('whatsappContact.template', { loading, unloading })
    },
    normalizePhone (phone) {
      return (phone || '').replace(/\D/g, '')
    },
    async track () {
      const data = {
        orderId: this.orderId,
        clickType: this.clickType
      }

      await Services.post('/order/userorderclickstatistic', data)
    },
    async openWhatsApp () {
      const normalizedPhone = this.normalizePhone(this.phone)
      if (!normalizedPhone) {
        return
      }

      await this.track()

      const message = this.getWhatsAppMessage()
      const url = message
        ? `https://wa.me/${normalizedPhone}?text=${encodeURIComponent(message)}`
        : `https://wa.me/${normalizedPhone}`

      window.open(url, '_blank')
    }
  }
}
</script>
